// components/portal/EntityPageTabs.tsx
import React from 'react';
import clsx from 'clsx';
import { GlassTabs } from '@/components/ui/GlassTabs';

interface EntityPageTab<T extends string = string> {
  id: T;
  label: string;
  hasPendingIndicator?: boolean;
}

interface EntityPageTabsProps<T extends string = string> {
  tabs: ReadonlyArray<EntityPageTab<T>>;
  activeTab: T;
  onTabChange: (tabId: T) => void;
  className?: string;
  sticky?: boolean;
}

/**
 * Entity-page tab bar — a thin wrapper over the shared glass segmented
 * control (`GlassTabs`, size="sm") so every entity detail page (Unit, Deal,
 * Lead, Brand, Portfolio, …) shares one consistent glass tab style instead
 * of the old underline row. `sticky` keeps the row pinned above the page's
 * scroll region.
 */
export function EntityPageTabs<T extends string>({
  tabs,
  activeTab,
  onTabChange,
  className,
  sticky = false,
}: EntityPageTabsProps<T>) {
  return (
    <GlassTabs
      tabs={tabs}
      activeTab={activeTab}
      onTabChange={onTabChange}
      size="sm"
      className={clsx('shrink-0 py-3', sticky && 'sticky top-0 z-20 bg-black', className)}
    />
  );
}
